import { get } from 'lodash/fp';

export const getIsBootstrapped = () => state => get('app.bootstrapped')(state);
